import React from 'react';
import DashboardHeader from '../components/layout/DashboardHeader';

const UserProfileLayout = ({ children }) => (
    <>
        <DashboardHeader navPosition="right" className="reveal-from-bottom" selected={"Profile"}/>
        <main className="site-content">
            {children}
        </main>
    </>
);

export default UserProfileLayout;